import { FC } from "react";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronLeft";
import DrawerToRender from "./drawerToRender";
import APP_LOGO from "./../../../assets/images/app-logo.png";
import { navigationDrawerNestedSx } from "../../../design-system/muiColorsOverrideHandler";

export const drawerWidth = 300;

const drawerHeaderIconButtonSx = {
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
} as const;

type NavigationDrawerProps = {
  selectedPage: string;
  window?: Window & typeof globalThis;
  onDrawerToggle?: (open: boolean) => void;
  drawerOpen: boolean;
};

const NavigationDrawer: FC<NavigationDrawerProps> = (props) => {
  const { selectedPage, drawerOpen, onDrawerToggle } = props;

  const handleDrawerOpen = () => {
    onDrawerToggle?.(true);
  };

  const handleDrawerClose = () => {
    onDrawerToggle?.(false);
  };

  return (
    <MuiDrawer
      data-testid="navigation-drawer"
      variant="permanent"
      open={drawerOpen}
      sx={(theme) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...(drawerOpen && {
          width: drawerWidth,
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          overflowX: "hidden",
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            overflowX: "hidden",
            ...navigationDrawerNestedSx,
          },
        }),
        ...(!drawerOpen && {
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          overflowX: "hidden",
          width: `calc(${theme.spacing(7)} + 1px)`,
          [theme.breakpoints.up("sm")]: {
            width: `calc(${theme.spacing(8)} + 1px)`,
          },
          "& .MuiDrawer-paper": {
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: "hidden",
            width: `calc(${theme.spacing(7)} + 1px)`,
            [theme.breakpoints.up("sm")]: {
              width: `calc(${theme.spacing(8)} + 1px)`,
            },
            ...navigationDrawerNestedSx,
          },
        }),
      })}
    >
      <Box
        id="drawerHeader"
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: theme.spacing(0, 1),
          ...theme.mixins.toolbar,
        })}
      >
        {drawerOpen ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={(theme) => ({
                fontFamily: theme.typography.fontFamily,
                fontWeight: 700,
                letterSpacing: "-0.02em",
                color: "#FFFFFF",
                backgroundImage: `url(${APP_LOGO})`,
                backgroundSize: 35,
                paddingLeft: 5,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "left center",
              })}
            >
              Varisht
            </Typography>
            <IconButton
              aria-label="close drawer"
              onClick={handleDrawerClose}
              edge="start"
              data-testid="close-drawer-button"
              sx={drawerHeaderIconButtonSx}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        ) : (
          <IconButton
            onClick={handleDrawerOpen}
            aria-label="open drawer"
            data-testid="open-drawer-button"
            sx={drawerHeaderIconButtonSx}
          >
            <ChevronRightIcon />
          </IconButton>
        )}
      </Box>
      <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.08)" }} />
      <DrawerToRender selectedPage={selectedPage} isMenuOpen={drawerOpen} />
    </MuiDrawer>
  );
};

export default NavigationDrawer;
